// extracted by mini-css-extract-plugin
module.exports = {"expiringRentContainer":"expiringRent_expiringRentContainer__6HyaG","separator":"expiringRent_separator__AOtGg"};